module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-instagram-3.b6c5fdb9.jpg";